export const FETCH_FOREX_COMPANIES_REQUEST = 'FETCH_FOREX_COMPANIES_REQUEST';
export const FETCH_FOREX_COMPANIES_SUCCESS = 'FETCH_FOREX_COMPANIES_SUCCESS';
export const FETCH_FOREX_COMPANIES_FAILURE = 'FETCH_FOREX_COMPANIES_FAILURE';
